import { Call, callEvents } from "@closerplatform/closer-sdk";
import {
  AbstractCallService,
  CallInfo,
  UserCallInfo
} from "@fidget/common/services/AbstractCallService";
import { Observable, Subject } from "rxjs";
import { logger } from "@fidget/common/utils";
import { RingtoneService } from "./ringtoneService";
import { ArtichokeService } from "@fidget/common/services/artichokeService";

export class AgentCallService extends AbstractCallService {
  private readonly callReceivedEvent = new Subject<UserCallInfo>();

  constructor(artichokeService: ArtichokeService, private ringtoneService: RingtoneService) {
    super(artichokeService);

    this.artichokeService.onConnected(() => {
      this.artichokeService.onCallInvitation((invited) => this.handleCallInvitation(invited));
    });
  }

  protected handleCallEnded(call: Call): void {
    this.ringtoneService.stopCallSound();
  }

  public get received$(): Observable<UserCallInfo> {
    return this.callReceivedEvent;
  }

  public async answer(call: CallInfo, audioTrack: MediaStreamTrack): Promise<void> {
    if (this.currentCall && this.isRequestCallValid(call)) {
      this.ringtoneService.stopCallSound();
      await this.currentCall.answer([audioTrack]);
      this.currentLocalAudioTrack = audioTrack;
      logger.debug("CallService: answered the call with audio track", audioTrack);
    }
  }

  private handleCallInvitation = (inviteEvent: callEvents.Invited) => {
    logger.debug("CallService: handling call invitation", inviteEvent);
    if (this.currentCall) {
      throw new Error("Call invitation received but there is a call in progress already");
    }
    this.ringtoneService.playCallSound();
    this.artichokeService.getCall(inviteEvent.callId).then((call) => {
      this.handleNewCall(call);
      this.callReceivedEvent.next({ callId: call.id, remoteUserId: call.creator });
    });
  };
}
